import script from "./NetworksCompanyComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NetworksCompanyComponent.vue?vue&type=script&setup=true&lang=js"

import "./NetworksCompanyComponent.vue?vue&type=style&index=0&id=2ffa46f0&lang=css"

const __exports__ = script;

export default __exports__